

cc.Class({
    extends: cc.Component,

    properties: {
        clickSound: '[sound atlas name here]'
    },

    onLoad () {
        this.audioManager = cc.find('AudioManager').getComponent('AudioManager');
        this.audioMap = cc.find('AudioMap').getComponent('AudioMap');

        this.node.on('click', () => {
            this.audioManager.play(this.audioMap[this.clickSound]);
        }, this);
    }
});
